module.exports = __webpack_public_path__ + "img/rada-seguros.61ccf152.png";